import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'saperp-connector-panel',
    templateUrl: './saperp.connector.panel.html'
})
export class SAPERPConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@SAP ERP',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.SAPERPInfo',
            ControlType: SAPERPConnectorPanel,
            Default: {
                ConnString : ""
            }
        };
    }

    validateSystemNumber() {
        const num = Number(this.Settings["SystemNumber"]);

        // Falls Buchstaben eingegeben wurden oder leer ist
        if (isNaN(num)) {
            this.Settings["SystemNumber"] = '0';
        }
        // Begrenzung auf maximal 99
        else if (num > 99) {
            this.Settings["SystemNumber"] = '99';
        }
        // Begrenzung auf minimal 0
        else if (num < 0) {
            this.Settings["SystemNumber"] = '0';
        }
    }
}
